import { usePrivacyConsentStore } from '@repo/privacy-consent';

import { getConfig } from '@shared/env';

let injected = false;

const injectScripts = (webStatisticsId: string): void => {
  if (injected) return;
  injected = true;

  const loaderScript = document.createElement('script');
  loaderScript.async = true;
  loaderScript.src = `https://www.googletagmanager.com/gtag/js?id=${webStatisticsId}`;
  document.head.appendChild(loaderScript);

  const inlineScript = document.createElement('script');
  inlineScript.text = `
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', '${webStatisticsId}');
  `;

  document.head.appendChild(inlineScript);
};

type PrivacyConsentState = ReturnType<typeof usePrivacyConsentStore.getState>;

const isGoogleAnalyticsConsented = (): boolean => usePrivacyConsentStore.getState().consents.googleAnalytics === true;

export const initWebStatistics = (): void => {
  const webStatisticsId = getConfig('webStatisticsId');
  if (webStatisticsId === undefined || webStatisticsId === '') return;

  if (isGoogleAnalyticsConsented()) {
    injectScripts(webStatisticsId);
  }

  usePrivacyConsentStore.subscribe((state: PrivacyConsentState, prevState: PrivacyConsentState) => {
    const next = state.consents.googleAnalytics === true;
    const prev = prevState.consents.googleAnalytics === true;
    if (next === prev) return;
    if (next) {
      injectScripts(webStatisticsId);
    }
  });
};
